/**
 * Who the Share dialog offers: members not already listed, never the owner.
 *
 * @module components/workflows/WorkflowShareDialog.logic
 */
import type { MemberChoice } from "./PeoplePicker";

export function shareableMembers(
  members: ReadonlyArray<MemberChoice>,
  people: ReadonlyArray<{ readonly email: string }>,
  ownerEmail: string | null,
): ReadonlyArray<MemberChoice> {
  const taken = new Set(people.map((person) => person.email.toLowerCase()));
  if (ownerEmail) taken.add(ownerEmail.toLowerCase());
  return members.filter((member) => !taken.has(member.email.toLowerCase()));
}
